export const voice = {
  play({ filePath, type, success, fail, complete }) {
    throw new Error("Function not implemented.")
  },
  stop({ success, fail, complete }) {
    throw new Error("Function not implemented.")
  },
  pause({ success, fail, complete }) {
    throw new Error("Function not implemented.")
  },
  isPause() {
    throw new Error("Function not implemented.")
  },
  resume({ success, fail, complete }) {
    throw new Error("Function not implemented.")
  },
  download(params) {
    throw new Error("Function not implemented.")
  },
  queuePlay(params) {
    throw new Error("Function not implemented.")
  }
} as VoiceDSL
